import {Grid, Card, CardContent, Button} from '@mui/material'

import { Plus } from 'react-feather'
import { useFechInitVehicleApplies } from './hooks';
import { useLocation, useParams } from 'react-router-dom';
import { AllowedAccess } from 'react-permission-role';
import { VehicleForm } from './VehicleForm/VehicleForm';
import { VehiclesSalesTable } from './VehiclesSalesTable/VehiclesSalesTable';
import { LinearLoading } from 'common';

export const VehiclesSales = () => {

  const location = useLocation();
  const paramsURL = useParams();
  const useFetchInit = useFechInitVehicleApplies({location, paramsURL})

  const {
    globalStates,
    Actions,
    FetchData
  } = useFetchInit

const { showForm} = globalStates

const {handleClickShowForm} = Actions

const { fetchAllVehicleSales: { loadingFetchVehicleSales } } = FetchData

  return (
    // <VehicleAppliesProvider >
    <AllowedAccess permissions={['101_VEHICULOS_VENTAS']} renderAuthFailed={<p>Error</p>}>
      <div className='content'>
        {(!showForm)&&(
          <div className='panel-body' id='listadoregistros'>
            <Grid container columnSpacing={{ xs: 12, sm: 12, md: 4, lg: 4 }}>
              <Grid item xs={12} sm={12} md={12} lg={12}>
                <Card>
                  <CardContent >
                    <div className='h4 mt-1 mb-1'> Venta de Vehiculos</div>
                    <div className="border-bottom border-dark"></div>

                    <Button
                      startIcon={<Plus />}
                      size='medium'
                      type='button'
                      variant='contained'
                      color='primary'
                      sx={{ marginTop: 4 }}
                      onClick={() => handleClickShowForm('EDITABLE')}
                    >
                      Agregar
                    </Button>

                    <div className="pt-4"></div>
                    {loadingFetchVehicleSales && <LinearLoading />}
                    <VehiclesSalesTable
                        useFetchInit={useFetchInit}
                    />
                  </CardContent>
                </Card>
              </Grid>
            </Grid>
          </div>
        )}
        {(showForm) && (
          <>
              <div className='panel-body' id='formularioregistros'>
                  <VehicleForm 
                      useFetchInit={useFetchInit}
                  />
              </div>
          </>
        )}
      </div>
    </AllowedAccess>

  )
}

